<!-- Full screen on a phone the header runs to the corner, so the X needs a row of its own above it. -->
<div
  class="tw:relative tw:flex tw:min-h-0 tw:flex-auto tw:flex-col tw:overflow-hidden tw:bg-black tw:text-white"
  [class]="showCloseButton() ? 'tw:max-[744px]:pt-10' : ''"
>
  @if (showCloseButton()) {
    <button class="dialog__close" (click)="closeDialog.emit()">
      <fr8bot-ui-icon name="menu-x" [size]="16" />
    </button>
  }

  @if (title(); as title) {
    <fr8bot-ui-page-template>
      <fr8bot-ui-page-header>
        <ng-container title>{{ title }}</ng-container>
      </fr8bot-ui-page-header>

      <ng-container [ngTemplateOutlet]="body" />
    </fr8bot-ui-page-template>
  } @else {
    <ng-container [ngTemplateOutlet]="body" />
  }
</div>

<!-- The last child is the table, or the list holding it: it takes the height the rest leave.
     Its display stays its own: the table is a grid, and its skeleton needs that grid to stretch. -->
<ng-template #body>
  <div
    class="tw:relative tw:flex tw:min-h-0 tw:flex-auto tw:flex-col tw:gap-[15px] tw:*:last:min-h-0 tw:*:last:flex-auto tw:*:last:overflow-hidden"
  >
    <ng-content />
  </div>
</ng-template>
